import { DropdownItemProps } from '@cas/components/inputs/dropdown-items/DropdownItems';
import { GeofenceAreaModel, useListGeofenceAreasQuery } from '@casops/store/apis/geofenceAreasApi';
import { useMemo } from 'react';

export const useAreaOptions = (): DropdownItemProps<number>[] => {
  const { data: areas } = useListGeofenceAreasQuery(undefined, {
    refetchOnMountOrArgChange: 120,
  });

  return useMemo<DropdownItemProps<number>[]>(() => {
    if (typeof areas !== 'undefined') {
      return areas.map(({ id, name }: GeofenceAreaModel) => ({
        key: id.toString(),
        value: id,
        stringValue: id.toString(),
        label: name,
      }));
    }
    return [];
  }, [areas]);
};

export default useAreaOptions;
